import React from "react";

export default function StepPanel({ active, stepId, title, description, theme, children }) {
  const classes = ["wizard-step"];
  if (active) classes.push("active");
  if (theme) classes.push("has-theme");

  const style = theme
    ? {
        "--step-accent": theme.accent,
        "--step-accent-soft": theme.soft,
        "--step-accent-glow": theme.glow,
        "--step-theme-image": `url(${theme.imageUrl})`,
      }
    : undefined;

  return (
    <div className={classes.join(" ")} data-step-id={stepId} style={style}>
      <h2>{title}</h2>
      <p className="step-desc">{description}</p>
      {children}
    </div>
  );
}
